/*!
 * JM Name Render v1.1 — script names (English 111 Vivace, made a little bolder) drawn as cut metal on a
 * no-name base photo. JMNameRender.draw(canvas, baseImg, layout, names, metal, opts)
 * layout: one entry per name slot, measured from the original photo:
 *   fontPx  letter size     e0, e1  where the chain meets the slot (start / end, in reading order)
 *   chainDirs (single-name necklace only)  chain ends + direction, to hang the chain down to the plate
 */
(function () {
  'use strict';
  var BG = [242, 242, 242];
  var PAL = {
    gold:   [[140, 105, 20], [214, 176, 64], [240, 206, 98], [248, 226, 140], [253, 242, 190]],
    silver: [[75, 75, 75], [150, 150, 150], [200, 200, 200], [222, 222, 222], [242, 242, 242]],
    rose:   [[131, 93, 57], [207, 169, 135], [240, 204, 172], [250, 220, 192], [253, 233, 212]]
  };
  function el(t) { return document.createElement(t); }
  function ramp(p, t) {
    t = Math.max(0, Math.min(1, t)) * 4; var i = Math.min(3, Math.floor(t)), f = t - i, a = p[i], b = p[i + 1];
    return [a[0] + (b[0] - a[0]) * f, a[1] + (b[1] - a[1]) * f, a[2] + (b[2] - a[2]) * f];
  }
  function measure(text, fontPx, fam) {
    var m = el('canvas').getContext('2d'); m.font = fontPx + 'px ' + fam;
    var t = m.measureText(text);
    return { l: t.actualBoundingBoxLeft, r: t.actualBoundingBoxRight, a: t.actualBoundingBoxAscent, d: t.actualBoundingBoxDescent, w: t.actualBoundingBoxLeft + t.actualBoundingBoxRight };
  }

  // a name as a metal plate. Origin returned as (ox, oy) = baseline centre of the text; the two end loops sit
  // 'loopUp' above the baseline, just beyond the first and last letter.
  function plate(text, fontPx, metal, loopUp, o) {
    o = o || {};
    var fam = o.font || 'JMVivace', thick = fontPx * (o.bold == null ? 0.03 : o.bold);
    var M = measure(text, fontPx, fam);
    var ring = fontPx * (o.ring || 0.075), pad = Math.ceil(thick + ring * 3 + 8);
    var top = Math.max(M.a, loopUp + ring) , bot = Math.max(M.d, -loopUp + ring);
    var W = Math.ceil(M.w + pad * 2), H = Math.ceil(top + bot + pad * 2);
    var cv = el('canvas'); cv.width = W; cv.height = H;
    var x = cv.getContext('2d');
    var bx = pad + M.l, by = pad + top;
    x.font = fontPx + 'px ' + fam; x.fillStyle = '#fff'; x.strokeStyle = '#fff';
    x.lineJoin = 'round'; x.lineCap = 'round'; x.lineWidth = thick * 2;
    x.fillText(text, bx, by); x.strokeText(text, bx, by);
    var ly = by - loopUp, l0 = [pad - ring * 0.6, ly], l1 = [W - pad + ring * 0.6, ly];
    // the loops reach in to the nearest metal of the first / last letter
    var A0 = x.getImageData(0, 0, W, H).data;
    function nearest(p) { // closest metal of the lettering to a loop
      var best = null, R = Math.ceil(fontPx * 0.45);
      for (var dy = -R; dy <= R; dy += 1) for (var dx = -R; dx <= R; dx += 1) {
        var xx = Math.round(p[0] + dx), yy = Math.round(p[1] + dy);
        if (yy < 0 || yy >= H || xx < 0 || xx >= W || A0[(yy * W + xx) * 4 + 3] < 200) continue;
        var dd = dx * dx + dy * dy; if (!best || dd < best[2]) best = [xx, yy, dd];
      }
      return best;
    }
    [l0, l1].forEach(function (p, i) {
      var t = nearest(p);
      // pull the loop in so it just touches the letter, then join them with a short tab
      if (t) { var d = Math.sqrt(t[2]), want = ring * 1.6; if (d > want) { var mv = (t[0] - p[0]) * (d - want) / d; p[0] += mv; } t = nearest(p); }
      if (t) { x.beginPath(); x.moveTo(p[0], p[1]); x.lineTo(t[0], t[1]); x.lineWidth = ring * 1.05; x.stroke(); }
      x.beginPath(); x.arc(p[0], p[1], ring, 0, Math.PI * 2); x.fill();
    });
    x.globalCompositeOperation = 'destination-out';
    [l0, l1].forEach(function (p) { x.beginPath(); x.arc(p[0], p[1], ring * 0.48, 0, Math.PI * 2); x.fill(); });
    x.globalCompositeOperation = 'source-over';
    // metal: bevel from a blurred copy of the shape, lit from the top left
    var A = x.getImageData(0, 0, W, H);
    var bc = el('canvas'); bc.width = W; bc.height = H; var bx2 = bc.getContext('2d');
    bx2.filter = 'blur(' + Math.max(1.2, fontPx * (o.bevel || 0.012)) + 'px)'; bx2.drawImage(cv, 0, 0);
    var B = bx2.getImageData(0, 0, W, H).data, D = A.data, pal = o.pal || PAL[metal] || PAL.gold;
    var L = [-0.5, -0.7, 0.5], ll = Math.hypot(L[0], L[1], L[2]); L = [L[0] / ll, L[1] / ll, L[2] / ll];
    var k = o.depth || 14, rot = o.rot || 0, cr = Math.cos(rot), sr = Math.sin(rot);
    for (var yy = 1; yy < H - 1; yy++) for (var xx = 1; xx < W - 1; xx++) {
      var i = (yy * W + xx) * 4; if (!D[i + 3]) continue;
      var gx = (B[i + 7] - B[i - 1]) / 255, gy = (B[i + 4 * W + 3] - B[i - 4 * W + 3]) / 255;
      // light stays fixed in the photo, so turn the normal by the plate's rotation
      var nx0 = -gx * k, ny0 = -gy * k, nx = nx0 * cr - ny0 * sr, ny = nx0 * sr + ny0 * cr, nz = 1, nl = Math.hypot(nx, ny, nz);
      nx /= nl; ny /= nl; nz /= nl;
      var dif = nx * L[0] + ny * L[1] + nz * L[2];
      var t = (o.base == null ? 0.7 : o.base) + (o.gain || 1.1) * (dif - 0.5) - (o.edge || 0.55) * (1 - B[i + 3] / 255);
      var c = ramp(pal, t);
      D[i] = c[0]; D[i + 1] = c[1]; D[i + 2] = c[2];
    }
    x.putImageData(A, 0, 0);
    return { cv: cv, ox: bx - M.l + M.w / 2, oy: by, l0: l0, l1: l1, ly: ly, span: l1[0] - l0[0], textW: M.w };
  }

  function draw(canvas, base, layout, names, metal, o) {
    o = o || {};
    var x = canvas.getContext('2d');
    canvas.width = base.naturalWidth || base.width; canvas.height = base.naturalHeight || base.height;
    x.drawImage(base, 0, 0);
    layout.forEach(function (s, i) {
      var text = (names[i] || '').trim(); if (!text) return;
      var fam = o.font || 'JMVivace';
      var fontPx = s.fontPx * (o.size || 1);
      // the plate hangs from the chain line: its two loops sit on the line from e0 to e1 (reading order)
      var ex = s.e1[0] - s.e0[0], ey = s.e1[1] - s.e0[1], el2 = Math.hypot(ex, ey);
      var a = Math.atan2(ey, ex), ux = ex / el2, uy = ey / el2;
      var room = el2 * (o.maxFill || 1.0);
      var w = measure(text, fontPx, fam).w;
      if (w > room) fontPx *= room / w;
      var up = fontPx * (o.loopUp == null ? 0.4 : o.loopUp);
      var P = plate(text, fontPx, metal, up, Object.assign({ rot: a }, o));
      var lmx = (P.l0[0] + P.l1[0]) / 2, lmy = P.ly;
      var cx = (s.e0[0] + s.e1[0]) / 2, cy = (s.e0[1] + s.e1[1]) / 2;
      x.save(); x.translate(cx, cy); x.rotate(a);
      x.fillStyle = 'rgb(' + BG.join(',') + ')';
      x.fillRect(P.l0[0] - lmx, -Math.max(14, fontPx * 0.16), P.span, 2 * Math.max(14, fontPx * 0.16));   // no chain between the loops
      x.drawImage(P.cv, -lmx, -lmy);
      x.restore();
      P.ox = lmx; P.oy = lmy;
      // single-name necklace: the chain hangs down to the plate's loops, so join each chain end to its loop
      if (s.chainDirs) {
        [P.l0, P.l1].forEach(function (l, k) {
          var lx = l[0] - P.ox, ly = l[1] - P.oy;
          var L = [cx + lx * ux - ly * uy, cy + lx * uy + ly * ux];
          bridge(x, base, s.chainDirs[k], L, fontPx);
        });
        // loops on top again
        x.save(); x.translate(cx, cy); x.rotate(a); x.drawImage(P.cv, -P.ox, -P.oy); x.restore();
      }
    });
  }

  // straight piece of chain from a chain end (cd.p, running up along cd.d) down to point L, made of the
  // photo's own links copied from just above the end
  function bridge(x, base, cd, L, fontPx) {
    var W = x.canvas.width, H = x.canvas.height;
    var sc = el('canvas'); sc.width = W; sc.height = H; var sx = sc.getContext('2d'); sx.drawImage(base, 0, 0);
    var tw = Math.round(fontPx * 0.12), len = Math.round(fontPx * 0.9), d = cd.d, n = [-d[1], d[0]];
    var src = sx.getImageData(0, 0, W, H).data;
    function at(px, py, c) { var xi = Math.round(px), yi = Math.round(py); if (xi < 0 || yi < 0 || xi >= W || yi >= H) return 242; return src[(yi * W + xi) * 4 + c]; }
    // repeat length of the links (autocorrelation along the strip)
    var prof = [], s1, t1;
    for (s1 = 0; s1 < len; s1++) { var acc = 0; for (t1 = -tw; t1 <= tw; t1++) { var px = cd.p[0] + d[0] * s1 + n[0] * t1, py = cd.p[1] + d[1] * s1 + n[1] * t1; acc += Math.abs(at(px, py, 0) - 242) + Math.abs(at(px, py, 2) - 242); } prof.push(acc); }
    var mean = prof.reduce(function (a2, b2) { return a2 + b2; }, 0) / len, per = 20, best = -1e18, lag, ac = [];
    for (lag = 4; lag < len / 2; lag++) { var c2 = 0; for (s1 = 0; s1 + lag < len; s1++) c2 += (prof[s1] - mean) * (prof[s1 + lag] - mean); ac.push(c2 / (len - lag)); }
    var i0 = 1; while (i0 < ac.length - 1 && !(ac[i0] <= ac[i0 - 1] && ac[i0] <= ac[i0 + 1])) i0++;
    for (var j = i0; j < ac.length; j++) if (ac[j] > best) { best = ac[j]; per = j + 4; }
    // lay it from the chain end to the loop
    var vx = L[0] - cd.p[0], vy = L[1] - cd.p[1], dist = Math.hypot(vx, vy); if (dist < 3) return;
    var ex = vx / dist, ey = vy / dist, nx = -ey, ny = ex;
    var x0 = Math.floor(Math.min(cd.p[0], L[0]) - tw - 2), x1 = Math.ceil(Math.max(cd.p[0], L[0]) + tw + 2);
    var y0 = Math.floor(Math.min(cd.p[1], L[1]) - tw - 2), y1 = Math.ceil(Math.max(cd.p[1], L[1]) + tw + 2);
    var img = x.getImageData(x0, y0, x1 - x0 + 1, y1 - y0 + 1), D = img.data, Wb = x1 - x0 + 1;
    for (var yy = y0; yy <= y1; yy++) for (var xx = x0; xx <= x1; xx++) {
      var rx = xx - cd.p[0], ry = yy - cd.p[1], kk = rx * ex + ry * ey, tt = rx * nx + ry * ny;
      if (kk < 0 || kk > dist || Math.abs(tt) > tw) continue;
      var sidx = (per - (kk % per)) % per;                 // walking away from the end = going back along the strip
      var qx = cd.p[0] + d[0] * sidx + n[0] * (-tt), qy = cd.p[1] + d[1] * sidx + n[1] * (-tt);
      var r = at(qx, qy, 0), g = at(qx, qy, 1), b = at(qx, qy, 2);
      var A = Math.max(0, Math.min(1, ((Math.abs(r - 242) + Math.abs(g - 242) + Math.abs(b - 242)) - 8) * 7 / 255));
      if (!A) continue;
      var o2 = ((yy - y0) * Wb + (xx - x0)) * 4;
      D[o2] = D[o2] * (1 - A) + r * A; D[o2 + 1] = D[o2 + 1] * (1 - A) + g * A; D[o2 + 2] = D[o2 + 2] * (1 - A) + b * A;
    }
    x.putImageData(img, x0, y0);
  }

  // ---- v1.1: names cut into a smooth blank chain -------------------------------------------------------
  // curve: { pts: [x0,y0,x1,y1,...] along the chain's centre line, hw: half width of the chain }
  // slots: [{ s: arc position of the name's centre, f: letter size, max: widest the plate may be }]
  // Each plate hangs with its two loops ON the chain; only the chain between the loops is taken away.
  function drawCurve(canvas, base, curve, slots, names, metal, o) {
    o = o || {};
    var x = canvas.getContext('2d');
    canvas.width = base.naturalWidth || base.width; canvas.height = base.naturalHeight || base.height;
    x.drawImage(base, 0, 0);
    var p = curve.pts, n = p.length / 2, S = [0];
    for (var i = 1; i < n; i++) S.push(S[i - 1] + Math.hypot(p[2 * i] - p[2 * i - 2], p[2 * i + 1] - p[2 * i - 1]));
    function at(s) {
      s = Math.max(0, Math.min(S[n - 1], s)); var lo = 0, hi = n - 1;
      while (hi - lo > 1) { var m = (lo + hi) >> 1; if (S[m] <= s) lo = m; else hi = m; }
      var f = (s - S[lo]) / Math.max(1e-6, S[hi] - S[lo]);
      return [p[2 * lo] + (p[2 * hi] - p[2 * lo]) * f, p[2 * lo + 1] + (p[2 * hi + 1] - p[2 * lo + 1]) * f];
    }
    var placed = [];
    slots.forEach(function (sl, i) {
      var text = (names[i] || '').trim(); if (!text) return;
      var f = sl.f * (o.size || 1), up, P, D, a, h, A, B;
      for (var pass = 0; pass < 3; pass++) {
        up = f * (o.loopUp == null ? 0.4 : o.loopUp);
        P = plate(text, f, metal, up, o); D = P.l1[0] - P.l0[0];
        if (!sl.max || D <= sl.max || pass === 2) break;
        f *= sl.max / D * 0.995;
      }
      // half-arc h so that the chord between the two loop points is exactly the loop distance
      var lo2 = D / 2, hi2 = D * 2;
      for (var it = 0; it < 40; it++) {
        h = (lo2 + hi2) / 2; A = at(sl.s - h); B = at(sl.s + h);
        if (Math.hypot(B[0] - A[0], B[1] - A[1]) < D) lo2 = h; else hi2 = h;
      }
      a = Math.atan2(B[1] - A[1], B[0] - A[0]);
      P = plate(text, f, metal, up, Object.assign({ rot: a }, o));   // relit for its angle
      placed.push({ P: P, A: A, a: a, s0: sl.s - h, s1: sl.s + h, f: f });
    });
    // take the chain away under each plate (the chain runs on into the loops)
    x.save(); x.strokeStyle = 'rgb(' + BG.join(',') + ')'; x.lineWidth = 2 * (curve.hw || 12); x.lineCap = 'butt'; x.lineJoin = 'round';
    placed.forEach(function (q) {
      var ring = q.f * (o.ring || 0.075), s0 = q.s0 + ring * (o.tuck == null ? 0.35 : o.tuck), s1 = q.s1 - ring * (o.tuck == null ? 0.35 : o.tuck);
      x.beginPath(); var c = at(s0); x.moveTo(c[0], c[1]);
      for (var s = s0 + 2; s < s1; s += 2) { c = at(s); x.lineTo(c[0], c[1]); }
      c = at(s1); x.lineTo(c[0], c[1]); x.stroke();
    });
    x.restore();
    placed.forEach(function (q) {
      x.save(); x.translate(q.A[0], q.A[1]); x.rotate(q.a); x.drawImage(q.P.cv, -q.P.l0[0], -q.P.l0[1]); x.restore();
    });
    return placed;
  }
  window.JMNameRender = { draw: draw, drawCurve: drawCurve, plate: plate, PAL: PAL };
})();
